/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default [
  {
    header: "Verwaltung",
    items: [
      { url: "/", name: "Dashboard", slug: "dashboard", icon: ["fad", "home"] },
      {
        url: "/resubmissions",
        name: "Wiedervorlagen",
        slug: "resubmissions",
        icon: ["fad", "repeat"]
      },
      {
        url: "/companies",
        name: "Firmen",
        slug: "companies",
        icon: ["fal", "building"]
      }
    ]
  },
  {
    hasPermissions: ["matcher"],
    header: "Anfragen",
    items: [
      {
        url: "/requests",
        name: "Anfragen",
        slug: "requests",
        icon: ["fas", "poll-people"],
        hasPermissions: ["matcher"]
      }
    ]
  },
  {
    header: "Stellen",
    items: [
      {
        url: "/jobs",
        name: "Projekte",
        slug: "jobs",
        icon: ["fal", "file-alt"]
      },
      {
        url: "/vacancies",
        name: "Stellenangebote",
        slug: "vacancies",
        icon: ["fal", "file-alt"]
      }
    ]
  },
  {
    header: "Bewerbungen",
    hasPermissions: ["applicants"],
    items: [
      {
        url: "/applicants",
        name: "Bewerber",
        icon: ["fal", "user-astronaut"],
        slug: "applicants",
        submenu: null,
        hasPermissions: ["applicants"]
      },
      {
        url: "/applicants/new",
        name: "Eingang",
        slug: "applicants_new",
        icon: ["fal", "door-open"],
        hasPermissions: ["applicants"]
      },
      {
        url: "/applicant/mails",
        name: "E-Mail Registrierung",
        slug: "applicants_mail",
        icon: ["fal", "envelope"],
        hasPermissions: ["applicants"]
      }
    ]
  },
  {
    header: "BI",
    hasPermissions: ["bi"],
    items: [
      {
        url: "/bi",
        name: "Dashboard",
        icon: ["fad", "home"],
        slug: "bi.dashboard",
        hasPermissions: ["bi"]
      },
      {
        url: "/bi/campaigns",
        name: "Kampagnen",
        slug: "bi.campaigns",
        icon: ["fal", "newspaper"],
        hasPermissions: ["bi"]
      },
      {
        url: "/bi/compare/vacancy",
        name: "Stellen Vergleichen",
        icon: ["fal", "exchange"],
        slug: "bi.compare.vacancy",
        hasPermissions: ["bi"]
      },
      {
        url: "/bi/compare/facebook",
        name: "FB Vergleichen",
        icon: ["fab", "facebook-f"],
        slug: "bi.compare.facebook",
        hasPermissions: ["bi"]
      },
      {
        url: "/bi/compare/google",
        name: "Google Vergleichen",
        icon: ["fab", "google"],
        slug: "bi.compare.google",
        hasPermissions: ["bi"]
      },
      {
        url: "/bi/compare/website",
        name: "Webseiten Report",
        icon: ["fal", "globe"],
        slug: "bi.compare.website",
        hasPermissions: ["bi"]
      },
      {
        url: "/bi/compare/consultant",
        name: "Berater Report",
        icon: ["fad", "user-tie"],
        slug: "bi.compare.consultant",
        hasPermissions: ["bi"]
      },
      {
        url: "/bi/compare/usergroup",
        name: "Standort Report",
        icon: ["fal", "city"],
        slug: "bi.compare.usergroup",
        hasPermissions: ["bi"]
      },
      {
        url: "/bi/compare/qrcodes",
        name: "Qr Codes",
        icon: ["fad", "qrcode"],
        slug: "bi.compare.qrcodes",
        hasPermissions: ["bi"]
      }
    ]
  },
  {
    header: "Administration",
    hasAnyPermissions: ["user_management", "coredata_management"],
    items: [
      {
        url: "/consultants",
        name: "Berater",
        slug: "consultants",
        icon: ["fad", "user-tie"],
        hasPermissions: ["user_management"]
      },
      {
        url: "/coredata",
        name: "Stammdaten",
        slug: "coredata",
        icon: ["fal", "tools"],
        hasPermissions: ["coredata_management"]
      }
    ]
  }
];
